import * as types from "./types";
import { requestAuth } from "../helpers/FetchApi";
import appSettings from "../AppSettings";

export const actionCreators = {
    GetCitiesSuggestions: (value, callback) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Widgets/Weather/Cities/" + value, {
            method: "GET"
        }).then((data) => {
            callback(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    GetStopPoints: (callback) => (dispatch, store) => {
        fetch("https://api.tfl.lu/v1/StopPoint",
            {
                method: "GET"
            })
            .then((response) => response.json())
            .catch((error) => {
                console.log(error);
            })
            .then(response => callback(response));
    },
    GetCitaCameras: (callback) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Widgets/Cita/", {
            method: "GET"
        }).then((data) => {
            callback(data);
        }).catch((data) => {
            console.log(data);
        });
    }
};
